/**
 * @file Automatically generated by barrelsby.
 */

export * from './login.component';
